import axios from "axios"
import { ISolicitudEmpresarial } from "../../../interfaces/ISolicitudEmpresarial";

export const getEmpresarial = async () => {
    return axios.get('api/Empresarial/GetTiene')
}

export const setSolicitud = async (postData: ISolicitudEmpresarial) => {
    return axios.post('api/Empresarial/SetSolicitud',postData)
}
